import { defineAIProviderManifest } from "../manifest";

export const manifest = defineAIProviderManifest({
  id: "googleGemini",
  label: "Google Gemini",
  description: "Connect to the Google Gemini API through a connector.",
  defaultBaseUrl: "https://generativelanguage.googleapis.com/v1beta",
  connectorIdentifier: "googleGemini",
  endpointFromConnector: true,
  defaultChatModel: "gemini-2.5-pro",
  defaultFastModel: "gemini-2.5-flash",
  configurable: true,
  requiresChatModel: false,
  contextLimitPatterns: ["exceeds the maximum number of tokens allowed"],
  credentialFields: [
    {
      key: "apiKey",
      label: "API key",
      description: "Supplied by the connector.",
      placeholder: "",
      sensitive: true,
      required: true,
    },
  ],
  packCredentials: (v) => ({ baseUrl: v.baseUrl?.trim() ?? "", apiKey: "" }),
  unpackCredentials: (row) => ({ baseUrl: row.baseUrl, apiKey: "" }),
  subtitleField: "baseUrl",
  attachmentSupport: {
    documentMediaTypes: ["application/pdf"],
    maxImageDimension: 2000,
  },
});
